module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/file-upload.f086c660.svg";